import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMexico = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M512 256A256 256 0 0 0 367.3 25.4v461.2A256 256 0 0 0 512 256z"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#6da544",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 256a256 256 0 0 0 144.7 230.6V25.4A256 256 0 0 0 0 256zM189.2 256a66.8 66.8 0 0 0 133.6 0v-22.3H189.2z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff9811",
			d: "M345 211.5h-66.7a22.3 22.3 0 0 0-44.6 0H167a23 23 0 0 0 23 22.2h-.8c0 12.3 10 22.3 22.3 22.3 0 12.3 10 22.3 22.2 22.3h44.6c12.3 0 22.2-10 22.2-22.3 12.3 0 22.3-10 22.3-22.3h-.8a23 23 0 0 0 23-22.2z"
		})
	]
});
export default SvgMexico;
